import {ValidationFunction} from "../validation-function";
import {ValidationResultItem} from "../validation-result-item";

const smallAlphabetNumberPattern = /^[0-9a-z]*$/;

export const smallAlphabetNumber: ValidationFunction = () => {
    return (s) => {
        if (!smallAlphabetNumberPattern.test(s)) {
            return [
                new ValidationResultItem(
                    "smallAlphabetNumber.pattern",
                    `英数字で入力してください。`,
                ),
            ];
        }
        return [];
    };
};
